import { render, staticRenderFns } from "./ChooseDict.vue?vue&type=template&id=5c6e47e0&scoped=true"
import script from "./ChooseDict.vue?vue&type=script&lang=js"
export * from "./ChooseDict.vue?vue&type=script&lang=js"
import style0 from "./ChooseDict.vue?vue&type=style&index=0&id=5c6e47e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e47e0",
  null
  
)

export default component.exports